module.exports = __webpack_public_path__ + "img/inactiveicon-hierarchy.d6d0fd4d.svg";